import React, { Component } from 'react';
import { connect } from 'react-redux';
import NumberFormat from 'react-number-format';
import Select from 'react-select';

// Components
import Loader from '../../utils/Loader';
import Modal from '../../modal/Modal';
import Button from '../../modal/Button';
import ShippingAddressModal from './ShippingAddressModal';

// State
import { getLocations, getProvinces } from '../../../store/actions/locations';
import {
    setShipping,
    setSavedShippingAddress,
    setActiveCheckoutSection,
} from '../../../store/actions/checkout';

// CSS
import '../../../css/custom-checkbox.css';
import '../../../css/shipping-form.css';
import '../../../css/react-select.css';

// Util
import {
    setCheckoutSectionActive as setCheckoutSectionActiveGA,
    setCheckoutSectionComplete as setCheckoutSectionCompleteGA,
} from '../../../utils/google-analytics';

class ShippingSection extends Component {
    constructor(props) {
        super(props);
        // Second ternary on company is to prevent 'FREE SHIPPING' from showing if someone went to free shipping, then back to ship to an address
        this.state = {
            showAddressModal: false,
            fname: !!props.shipping.fname ? props.shipping.fname : '',
            lname: !!props.shipping.lname ? props.shipping.lname : '',
            company: !!props.shipping.company
                ? !!props.isStore
                    ? props.shipping.company
                    : ''
                : '',
            address: !!props.shipping.address ? props.shipping.address : '',
            address_2: !!props.shipping.address_2 ? props.shipping.address_2 : '',
            city: !!props.shipping.city ? props.shipping.city : '',
            postal: !!props.shipping.postal ? props.shipping.postal : '',
            country: !!props.shipping.country ? props.shipping.country : '',
            province: !!props.shipping.province ? props.shipping.province : '',
            phone: !!props.shipping.phone ? props.shipping.phone : '',
            save_address: !!props.shipping.id ? props.shipping.id : '',
        };
    }

    // ===================================
    //  LIFE CYCLE HOOKS
    // ===================================
    componentDidMount() {
        this.props.getLocations(true);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.default_country !== null && this.state.country === '') {
            this.setState({
                country: nextProps.default_country,
            });
        }
    }

    // ===================================
    //  INPUT
    // ===================================
    updateSelectedCountry = (country) => {
        this.setState(
            {
                country: country.id,
                province: '',
            },
            () => this.props.getProvinces(this.state.country, true)
        );
    };

    updateSelectedProvince = (province) => {
        this.setState({
            province: province.abbreviation,
        });
    };

    handleInputChange(event) {
        this.setState({
            [event.target.id]: event.target.value,
        });
    }

    handleKeyPress(event, item_id) {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.handleSubmit();
        }
    }

    handleNumberChange(id, valueObject) {
        this.setState({
            [id]: valueObject.value,
        });
    }

    handeAddressSelect = (shippingData) => {
        this.setState({ showAddressModal: false });
        this.props.setSavedShippingAddress(shippingData);
        this.finishUp();
    };

    finishUp = () => {
        // Set current section as complete
        setCheckoutSectionCompleteGA(3);

        if (this.props.isStore) {
            setCheckoutSectionCompleteGA(4);
            // Set Billing active
            setCheckoutSectionActiveGA(5);
            this.props.setActiveCheckoutSection('billing');
        } else {
            // Set Shipping Payment active
            setCheckoutSectionActiveGA(4);
            this.props.setActiveCheckoutSection('shipping-payment');
        }
    };

    handleSaveChange = (event) => {
        this.setState({ save_address: event.target.checked });
    };

    // ===================================
    //  RENDER
    // ===================================
    render() {
        const {
            user,
            shipping,
            countries,
            provinces,
            errors,
            locationsError,
            locationsLoading,
        } = this.props;
        // const shipping_country = 1
        var notGuest =
            user.customer && Object.keys(user.customer.user).length ? true : false;
        return (
            <div>
                <div className="delivery-heading">
                    <h2>Enter a Shipping Address:</h2>

                    {notGuest && (
                        <div>
                            <div
                                className={
                                    'btn btn--red btn--heading' +
                                    (this.props.shippingCheckInProgress ? ' loading' : '')
                                }
                                disabled={this.props.shippingCheckInProgress}
                                onClick={() => this.setState({ showAddressModal: true })}
                            >
                                Choose Saved Address
                            </div>

                            {/* ADDRESS MODAL */}
                            {this.state.showAddressModal && (
                                <Modal
                                    title={'Choose Address'}
                                    buttons={[
                                        {
                                            type: Button,
                                            text: 'Close',
                                            action: () =>
                                                this.setState({
                                                    showAddressModal: false,
                                                }),
                                            disabled: this.props.deleteInProcess,
                                        },
                                    ]}
                                >
                                    <ShippingAddressModal
                                        handleSelect={this.handeAddressSelect}
                                    />
                                </Modal>
                            )}
                        </div>
                    )}
                </div>

                <form className="shipping-form tight-form-fields">
                    {!!shipping && shipping.id && (
                        <input type="hidden" name="id" value={shipping.id} />
                    )}

                    <div className="floated-field-container">
                        <div className="form-field no-label-field half-field">
                            <label htmlFor="fname">First Name:</label>

                            {!!errors.fname && (
                                <div className="error">{errors.fname}</div>
                            )}

                            <input
                                type="text"
                                name="fname"
                                id="fname"
                                value={this.state.fname}
                                placeholder="First Name"
                                onKeyPress={(e) => this.handleKeyPress(e)}
                                onChange={(event) => this.handleInputChange(event)}
                            />
                        </div>

                        <div className="form-field no-label-field half-field">
                            <label htmlFor="lname">Last Name:</label>

                            {!!errors.lname && (
                                <div className="error">{errors.lname}</div>
                            )}

                            <input
                                type="text"
                                name="lname"
                                id="lname"
                                value={this.state.lname}
                                placeholder="Last Name"
                                onKeyPress={(e) => this.handleKeyPress(e)}
                                onChange={(event) => this.handleInputChange(event)}
                            />
                        </div>
                    </div>

                    <div className="form-field no-label-field">
                        <label htmlFor="password">Company:</label>

                        {!!errors.company && (
                            <div className="error">{errors.company}</div>
                        )}

                        <input
                            type="text"
                            name="company"
                            id="company"
                            value={this.state.company}
                            placeholder="Company"
                            onKeyPress={(e) => this.handleKeyPress(e)}
                            onChange={(event) => this.handleInputChange(event)}
                        />
                    </div>

                    <div className="form-field no-label-field">
                        <label htmlFor="password">Address:</label>

                        {!!errors.address && (
                            <div className="error">{errors.address}</div>
                        )}

                        <input
                            type="text"
                            name="address"
                            id="address"
                            value={this.state.address}
                            placeholder="Address"
                            onKeyPress={(e) => this.handleKeyPress(e)}
                            onChange={(event) => this.handleInputChange(event)}
                        />
                    </div>
                    <div className="form-field no-label-field">
                        <label htmlFor="address_2">Address 2:</label>

                        {!!errors.address_2 && (
                            <div className="error">{errors.address_2}</div>
                        )}

                        <input
                            type="text"
                            name="address_2"
                            id="address_2"
                            value={this.state.address_2}
                            placeholder="Address Line 2"
                            onKeyPress={(e) => this.handleKeyPress(e)}
                            onChange={(event) => this.handleInputChange(event)}
                        />
                    </div>

                    <div className="floated-field-container">
                        <div className="form-field no-label-field half-field">
                            <label htmlFor="city">City:</label>

                            {!!errors.city && <div className="error">{errors.city}</div>}

                            <input
                                type="text"
                                name="city"
                                id="city"
                                value={this.state.city}
                                placeholder="City"
                                onKeyPress={(e) => this.handleKeyPress(e)}
                                onChange={(event) => this.handleInputChange(event)}
                            />
                        </div>

                        <div className="form-field no-label-field half-field">
                            <label htmlFor="postal">Postal:</label>

                            {!!errors.postal && (
                                <div className="error">{errors.postal}</div>
                            )}

                            <input
                                type="text"
                                name="postal"
                                id="postal"
                                value={this.state.postal}
                                placeholder="Postal"
                                onKeyPress={(e) => this.handleKeyPress(e)}
                                onChange={(event) => this.handleInputChange(event)}
                            />
                        </div>
                    </div>

                    {locationsError ? (
                        <div className="error top-margin">{locationsError}</div>
                    ) : locationsLoading ? (
                        <div className="pt2 pb2">
                            <Loader />
                        </div>
                    ) : (
                        <div className="floated-field-container">
                            <div className="form-field no-label-field half-field">
                                <label htmlFor="country">Country:</label>

                                {!!errors.country && (
                                    <div className="error">{errors.country}</div>
                                )}

                                <Select
                                    classNamePrefix="react-select"
                                    name={`country`}
                                    placeholder="Country"
                                    value={countries.filter(
                                        ({ id }) => id === this.state.country
                                    )}
                                    onChange={(selection) =>
                                        this.updateSelectedCountry(selection)
                                    }
                                    isClearable={false}
                                    getOptionLabel={({ title }) => title}
                                    getOptionValue={({ id }) => id}
                                    options={countries}
                                />
                            </div>

                            <div className="form-field no-label-field half-field">
                                <label htmlFor="province">Province:</label>

                                {!!errors.province && (
                                    <div className="error">{errors.province}</div>
                                )}

                                <Select
                                    classNamePrefix="react-select"
                                    name={`province`}
                                    placeholder={
                                        this.state.country === 'CA' ? 'Province' : 'State'
                                    }
                                    value={provinces.filter(
                                        ({ abbreviation }) =>
                                            abbreviation === this.state.province
                                    )}
                                    onChange={(selection) =>
                                        this.updateSelectedProvince(selection)
                                    }
                                    isClearable={false}
                                    getOptionLabel={({ name }) => name}
                                    getOptionValue={({ abbreviation }) => abbreviation}
                                    options={provinces}
                                />
                            </div>
                        </div>
                    )}

                    <div className="floated-field-container">
                        <div className="form-field no-label-field half-field">
                            <label htmlFor="phone">Phone:</label>

                            {!!errors.phone && (
                                <div className="error">{errors.phone}</div>
                            )}

                            <NumberFormat
                                value={this.state.phone}
                                format="### ### ####"
                                mask="_"
                                placeholder="Phone number"
                                onKeyPress={(e) => this.handleKeyPress(e)}
                                onValueChange={(e) => this.handleNumberChange('phone', e)}
                            />
                        </div>
                    </div>

                    <div className="btn_container">
                        {!!errors.general && (
                            <div className="error">{errors.general}</div>
                        )}

                        {notGuest && (
                            <div className="form-field half-field">
                                <div className="custom-label checkbox-label no-bottom-margin">
                                    <input
                                        type="checkbox"
                                        id="save_address"
                                        name="save_address"
                                        value="1"
                                        checked={this.state.save_address}
                                        onChange={(event) => this.handleSaveChange(event)}
                                    />
                                    <label htmlFor="save_address">Save Address</label>
                                </div>
                            </div>
                        )}

                        <button
                            className={
                                'btn submit-btn' +
                                (this.props.shippingCheckInProgress ? ' loading' : '')
                            }
                            disabled={this.props.shippingCheckInProgress}
                            onClick={(e) => {
                                e.preventDefault();
                                this.props.setShipping(this.state).then((resp) => {
                                    if (resp !== undefined) {
                                        this.finishUp();
                                    }
                                });
                            }}
                        >
                            <span>Use Address</span>
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        shipping: state.checkout.shipping,
        errors: state.checkout.shippingErrors,
        countries: state.locations.countries,
        default_country: state.locations.default_country,
        provinces: state.locations.provinces,
        locationsLoading: state.locations.isLoading,
        locationsError: state.locations.error,
        shippingCheckInProgress: state.checkout.shippingCheckInProgress,
        isStore: state.checkout.isStore,
    };
};

export default connect(
    mapStateToProps,
    {
        getLocations,
        getProvinces,
        setShipping,
        setSavedShippingAddress,
        setActiveCheckoutSection,
    }
)(ShippingSection);



// WEBPACK FOOTER //
// ./src/components/checkout/shipping/ShippingSection.js